export const TIERS = [
  { id: 'nano', label: 'Nano', icon: 'N', tip: 'Nano · 1,000–9,999 followers' },
  { id: 'micro', label: 'Micro', icon: 'Mi', tip: 'Micro · 10,000–99,999 followers' },
  { id: 'mid', label: 'Mid', icon: 'Md', tip: 'Mid · 100,000–499,999 followers' },
  { id: 'mega', label: 'Mega', icon: 'Me', tip: 'Mega · 500,000+ followers' },
];

export const tierMeta = (id) => TIERS.find((t) => t.id === id);
